import { Button, Card } from "react-bootstrap";

export interface UnauthorizedNoticeProps {
  onSignOut: () => Promise<void>;
}

const UnauthorizedNotice = ({ onSignOut }: UnauthorizedNoticeProps) => (
  <Card className="shadow-sm auth-card">
    <Card.Body>
      <Card.Title className="text-center mb-3">Access not granted</Card.Title>
      <Card.Text className="text-muted text-center mb-4">
        Your Firebase user signed in successfully, but it must have the{" "}
        <strong>platformPanelAccess</strong> claim and the <strong>god</strong>{" "}
        role to continue. Please contact platform operations to be added to the
        allowlist.
      </Card.Text>
      <div className="d-flex justify-content-center">
        <Button variant="outline-secondary" onClick={onSignOut}>
          Sign out
        </Button>
      </div>
    </Card.Body>
  </Card>
);

export default UnauthorizedNotice;
